export const MEAT_API = 'https://jmrpainelfinanceiroapi.a2rs10.com.br'
// export const MEAT_API = 'http://localhost:51652'


